import {Component, effect, inject, OnDestroy} from '@angular/core';
import {SharedModule} from '../../../shared';
import {SystemFile} from '../../../../models/api/system-file.model';
import {FormBuilder, FormControl} from '@angular/forms';
import {select, Store} from '@ngxs/store';
import {AnnexActions} from '../../../../state/annex/annex.actions';
import {AnnexState} from '../../../../state/annex/annex.state';

@Component({
    selector: 'app-protection-period-correction-modal',
    templateUrl: './protection-period-correction-modal.component.html',
    imports: [SharedModule],
})
export class ProtectionPeriodCorrectionModalComponent implements OnDestroy {
    protected store = inject(Store);

    results = select(AnnexState.protectionPeriodCorrectionResult);
    error = select(AnnexState.protectionPeriodCorrectionError);
    protected fileControl: FormControl<SystemFile> = inject(FormBuilder).control<SystemFile>(null);
    readonly extensions = ['xlsx'];

    constructor() {
        effect(() => {
            this.fileControl.setErrors(this.error() ? {serviceError: this.error()} : null);
        });
    }

    fileListChanged(fileList: SystemFile[]) {
        const lastFile = fileList?.length ? fileList[fileList.length - 1] : null;
        this.fileControl.setValue(lastFile);
        const actions = [new AnnexActions.ClearProtectionPeriodCorrectionResult()];
        if (lastFile) {
            actions.push(new AnnexActions.CorrectProtectionPeriod(lastFile));
        }
        this.store.dispatch(actions);
    }

    ngOnDestroy() {
        this.store.dispatch(new AnnexActions.ClearProtectionPeriodCorrectionResult());
    }
}
